import { initHydration } from './initHydration';
export const islands = () => {
    const elements = document.querySelectorAll('gu-island');
    initHydration(elements);
    return Promise.resolve();
};
